import styled, { keyframes, css } from "styled-components";

export const ModuleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const Report = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #f8e47c;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ccc;
`;

export const FilterLine = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: 5px;
`;

export const IconContainer = styled.div`
  background-color: #f8e47c;
  color: #42464c; //#ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin-right: 1rem;
`;

export const IconStyle = {
  color: "inherit",
  fontSize: "24px",
};

export const ExtentionContainer = styled.div`
  height: 40rem;
  overflow-y: auto;
  margin-top: 0.5rem;

  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: gainsboro;
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: #212326;
    border-radius: 6px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #000;
  }
`;

export const RefreshDeleteContainer = styled.div`
  position: absolute;
  right: 5px;
  top: 0px;
  display: flex;
  gap: 8px;
`;
